import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ItemComponent } from "react-simple-tree-menu";
import enter from "../../../Assets/img/Dashboard/enter.png";

const MenuNavItem = (props) => {
  const history = useHistory();
  const [image, setImage] = useState("");

  (function (imageName) {
    if (imageName != "") {
      import(`../../../Assets/img/Dashboard/${imageName}`).then((image) =>
        setImage(image.default)
      );
    }
  })(props.imageURL);

  return (
    <div
      className={`itemMenu__Container ${
        props.active && "itemMenu__Container__active"
      }`}
      style={{ marginLeft: `${props.level * 20}px` }}
    >
      {props.imageURL == "" ? (
        <div />
      ) : (
        <img
          className="imgIconsMenu"
          src={image}
          onClick={() => props.hasNodes && props.toggleNode()}
        />
      )}
      <ItemComponent onClick={()=>alert(props.url)} {...props} />
      <button
        className="btnEnter_MenuNav"
        onClick={() => history.push(props.url)}
      >
        <img className="iconEnter_MenuNav" src={enter} />
      </button>
    </div>
  );
};
export default MenuNavItem;
